import React from "react";
import './PostSidebar.css'
import { Link } from "gatsby";
export const PostSidebar: React.FC = () => {
  return (
    <>
      <div className="sidebar">

        <h3 className="sidebar-title">Categories</h3>
        <div className="sidebar-item categories">
          <ul>
          <li><Link to="/tags/business-ideas">Onlinr Business Ideas</Link></li>
          <li><Link to="/tags/wordpress">Wordpress </Link></li>
          <li><Link to="/tags/business-case-study">Business Case Studies</Link></li>
          <li><Link to="/tags/business-growth-hacking">Business Growth Hacking</Link></li>
          </ul>
        </div>
        <hr/>
        <Link className='img-wrapper' to='/graphic-templates'><img className='zoom-on-hover' src="/sidebar/templates.jpg" alt="Canva Templates Bundle" /></Link>
        <hr/>
        <Link className='img-wrapper' to='/resources'><img className='zoom-on-hover' src="/sidebar/business_bundle.jpg" alt="Business Quickstart Guides Bundle" /></Link>
        <hr/>
        <Link className='img-wrapper' to='/guides/lead-generation'><img className='zoom-on-hover' src="/sidebar/lead_generation_guide.jpg" alt="Lead Generation Guide" /></Link>
        <hr/>
        <div className="container p-0">
       <a data-pin-do="embedUser" data-pin-board-width="300" data-pin-scale-height="500" data-pin-scale-width="60" href="https://in.pinterest.com/bizdamn/"></a>
       </div>
        <hr/>
        <Link className='img-wrapper' to='/guides/kindle-best-seller'><img className='zoom-on-hover' src="/sidebar/kindle_best_seller.jpg" alt="Kindle eBook Publishing Guide" /></Link>
        <hr/>
        <Link className='img-wrapper' to='/guides/blogging'><img className='zoom-on-hover' src="/sidebar/blog_guide.jpg" alt="Bloggging Guide" /></Link>
        <hr/>
       
      </div>
    </>
  );
};